import Adduser from "./Adduser";
import { Route, Routes } from "react-router";
import ManageUsers from "./ManageUsers";
import OrganizationSidebar from "./OrganizationSidebar";
import PaymentAccount from "./PaymentAccount";
import Reports from "./Reports";
import "./organizationStyles.css";
import "./Templete/template.css";
import "./Reports/reports.css";
import TempleteView from "./Templete/TempleteView";
import AddTemplate from "./Templete/AddTemplate/AddTemplate";
import AddLeaseAgreementTemplate from "./Templete/LeaseTemplate/AddLeaseAgreementTemplate";
import FeesAndCommissions from "./FeesAndCommissions/index";
import PaymentProcessingDates from "./PaymentProcessingDates/index";
import PayeeAccounts from "./PayeeAccounts";
import OrganizationOverview from "./BasicDetails/OrganizationOverview";
import DateHelper from "../../utils/DateHelper";
import OverviewPage from "../../newDashboard/Pages/overview";
import PaymentAccountsPage from "../../newDashboard/Pages/payment-accounts";
import PayeeAccountsPage from "../../newDashboard/Pages/payee-accounts";
import ManageUsersPage from "../../newDashboard/Pages/manage-users";

export const MyOrganization = () => {
  return (
    <>
      <div className="organizationContentContainer d-flex">
        <OrganizationSidebar pageType="organization" />
        <div className="openedMenuRightSideDashboard">
          <Routes>
          <Route path="/templates/create" element={<AddTemplate />} />
          <Route path="/templates/create-lease-agreement" element={<AddLeaseAgreementTemplate />} />
          <Route path="/templates/lease-agreement/:id" element={<AddLeaseAgreementTemplate />} />
          <Route path="/templates/edit/:id" element={<AddTemplate />} />
          <Route path="/overview" element={<OrganizationOverview />} />
          <Route path="/new-overview" element={<OverviewPage />} />
          <Route path="/manage-users/create" element={<Adduser />} />
          <Route path="/manage-users/edit/:id" element={<Adduser />} />
          <Route path="/payment-account" element={<PaymentAccount />} />
          <Route path="/new-payment-accounts" element={<PaymentAccountsPage />} />
          <Route path="/payee-accounts" element={<PayeeAccounts />} />
          <Route path="/new-payee-accounts" element={<PayeeAccountsPage />} />
          <Route path="/manage-users" element={<ManageUsers />} />
          <Route path="/new-manage-users" element={<ManageUsersPage />} />
          <Route path="/templates" element={<TempleteView />} />
          <Route path="/fees-and-commissions" element={<FeesAndCommissions />} />
          <Route path="/payment-processing-dates" element={<PaymentProcessingDates />} />
          <Route path="/reports" element={<Reports  />} />
        </Routes>
        </div>
        
      </div>
    </>
  );
};
